/* eslint-disable */
import leaflet from 'leaflet'

export default {
  name: 'leaflet-map',

  ui: {
    'filters[]': '[js-map-filter]',
  },

  events: [
    {
      target: 'filters',
      on: 'click',
      handle(e) {
        const target = e.currentTarget
        for (const f of this.ui.filters) {
          if (f !== target) f.classList.remove('is-active')
        }
        target.classList.toggle('is-active')

        for (const marker of this.markersArray) {
          marker.setIcon(this.unselectedIcon)
        }

        this.clearInfos()

        let selectionArray = []
        if (target.classList.contains('is-active')) {
          const filter = target.getAttribute('js-map-filter')

          if (filter === 'headoffice') {
            selectionArray = this.markersArray.filter(
              m => m.options.data.isHeadOffice
            )
            setTimeout(() => {
              this.fillInfos(selectionArray[0].options.data)
            }, 400)
          } else if (filter === 'franceLocated') {
            selectionArray = this.markersArray.filter(
              m => m.options.data.franceLocated
            )
          } else if (filter === 'outsideLocated') {
            selectionArray = this.markersArray.filter(
              m => !m.options.data.franceLocated
            )
          } else {
            console.log('here')
          }

          this.latlngbounds = leaflet.latLngBounds()

          if (selectionArray.length <= 0) {
            selectionArray = [...this.markersArray]
          }

          for (const marker of selectionArray) {
            marker.setIcon(this.selectedIcon)
            this.latlngbounds.extend([
              marker.getLatLng().lat,
              marker.getLatLng().lng,
            ])
          }
        } else {
          selectionArray = [...this.markersArray]

          for (const marker of selectionArray) {
            marker.setIcon(this.unselectedIcon)
            this.latlngbounds.extend([
              marker.getLatLng().lat,
              marker.getLatLng().lng,
            ])
          }
        }

        this.centerMap()
      },
    },
  ],

  componentDidMount() {
    this.markersArray = []
    if (this.props && this.props.markers) {
      this.markersList = this.props.markers
    }

    this.map = leaflet
      .map('map')
      .setView([44.170933800000014, -8.10194147499999], 5)
    leaflet
      .tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution:
          '&copy <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      })
      .addTo(this.map)

    this.selectedIcon = L.icon({
      iconUrl: '/assets/front/marker.png',
      iconSize: [28, 43],
      iconAnchor: [14, 43],
    })

    this.unselectedIcon = L.icon({
      iconUrl: '/assets/front/marker_unselected.png',
      iconSize: [30, 30],
      iconAnchor: [15, 15],
    })

    this.infos = this.el.querySelector('.slice__map__infos')
    this.infosTitle = this.infos.querySelector('.slice__map__infos__title')
    this.infosAddress = this.infos.querySelector(
      '.slice__map__infos__address span'
    )
    this.infosphone = this.infos.querySelector('.slice__map__infos__phone span')
    this.infosmail = this.infos.querySelector('.slice__map__infos__email span')
    this.infosweb = this.infos.querySelector('.slice__map__infos__web span')

    this.displayMarkers()
  },

  displayMarkers() {
    this.latlngbounds = leaflet.latLngBounds()

    this.markersList.forEach(m => {
      var marker = leaflet
        .marker([m.location.lat, m.location.lng], {
          icon: this.unselectedIcon,
          title: m.title,
          data: m,
        })
        .addTo(this.map)
        .on('click', this.clickMarker)

      this.markersArray.push(marker)

      this.latlngbounds.extend([m.location.lat, m.location.lng])
    })

    this.centerMap(true)
  },

  centerMap() {
    this.map.fitBounds(this.latlngbounds)
  },

  clickMarker(e) {
    this.markersArray.forEach((el, index) => {
      el.setIcon(this.unselectedIcon)
    })

    e.target.setIcon(this.selectedIcon)

    this.fillInfos(e.target.options.data)
  },

  fillInfos(m) {
    this.infosTitle.innerHTML = m.title
    const formatAddress = m.address
      ? m.address.replace(/^,\s*|\s*,$/g, '').trim()
      : ''
    this.infosAddress.innerHTML = formatAddress
    // PHONE
    if (m.phone !== '') this.infosphone.innerHTML = m.phone
    else this.infosphone.parentElement.classList.add('hidden')
    // mail
    if (m.email !== '') this.infosmail.innerHTML = m.email
    else this.infosmail.parentElement.classList.add('hidden')
    // website
    if (m.website !== '') this.infosweb.innerHTML = m.website
    else this.infosweb.parentElement.classList.add('hidden')

    this.infos.classList.add('is-active')
  },

  clearInfos() {
    this.infos.classList.remove('is-active')
    setTimeout(() => {
      this.infosTitle.innerHTML = ''
      this.infosAddress.innerHTML = ''
      this.infosphone.innerHTML = ''
      this.infosphone.parentElement.classList.remove('hidden')
      this.infosmail.innerHTML = ''
      this.infosmail.parentElement.classList.remove('hidden')
      this.infosweb.innerHTML = ''
      this.infosweb.parentElement.classList.remove('hidden')
    }, 300)
  },
}
